import { render } from "./myaddress.vue?vue&type=template&id=85e67afa&scoped=true"
import script from "./myaddress.vue?vue&type=script&lang=js"
export * from "./myaddress.vue?vue&type=script&lang=js"

import "./myaddress.vue?vue&type=style&index=0&id=85e67afa&lang=scss"
import "./myaddress.vue?vue&type=style&index=1&id=85e67afa&lang=scss"
import "./myaddress.vue?vue&type=style&index=2&id=85e67afa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e67afa"]])

export default __exports__